export default {
  // finance-debt-meta.tsx
  Amount: "Montant",
  Payer: "Payeur",
  Receiver: "Bénéficiaire",
  "Due Date": "Date d'échéance",
  "Payment Date": "Date de paiement",
  Actions: "Actions",

  // finance-debt-form.tsx
  "Payer Type": "Type de payeur",
  "Select payer type": "Sélectionner le type de payeur",
  "Select payer": "Sélectionner le payeur",
  "Receiver Type": "Type de bénéficiaire",
  "Select receiver type": "Sélectionner le type de bénéficiaire",
  "Select receiver": "Sélectionner le bénéficiaire",

  // select-finance-debt.tsx
  "Finance Debt": "Dette financière",
  "Search by amount, payer or receiver":
    "Rechercher par montant, payeur ou bénéficiaire",
  "Edit Selection": "Modifier la sélection",
  "No debts found": "Aucune dette trouvée",
  Due: "Échéance",

  // create-finance-debt-modal.tsx
  "Create a new debt": "Créer une nouvelle dette",

  // edit-finance-debt-modal.tsx
  "Edit Debt": "Modifier la dette",

  // view-finance-debt-modal.tsx
  "Debt Details": "Détails de la dette",
  Transaction: "Transaction",
  "Created At": "Créé le",
  "Updated At": "Mis à jour le",

  // delete-finance-debt-modal.tsx
  "Do you really want to delete this debt?":
    "Voulez-vous vraiment supprimer cette dette ?",
  "Warning: This action is irreversible.":
    "Attention : cette action est irréversible.",
  "Confirm Deletion": "Confirmer la suppression",
  Cancel: "Annuler",

  // finance-debt-list-block.tsx
  "Finance Debts": "Dettes financières",
  "Add debt": "Ajouter une dette",

  // Entity types
  Customer: "Client",
  Supplier: "Fournisseur",
  Employee: "Employé",

  Submit: "Soumettre",
  "Customers debts": "Dettes des clients",
  "Supplier credits": "Crédits fournisseurs",
  "Suppliers credits": "Crédits fournisseurs",
  "Suppliers debts": "Dettes des fournisseurs",
  "Copy to clipboard": "Copier dans le presse-papier",
  "All Statuses": "Tous les statuts",
  amount: "montant",
  Status: "Statut",
  status: "statut",
  "Add customer debt": "Enregistrer une dette",
  "Add supplier credit": "Enregistrer un crédit",

  Remaining: "Restant",
  remaining: "restant",
  payer: "payeur",
  receiver: "bénéficiaire",
  actions: "actions",
  customer: "client",
  supplier: "fournisseur",
  Paid: "Payé",
  paid: "payé",
  Pending: "En attente",
  pending: "en attente",
  Overdue: "En retard",
  overdue: "en retard",
  "Create New Debt": "Créer une nouvelle dette",
  "Total Debt Amount": "Montant total de la dette",
  "Expected Payment Date": "Date de paiement prévue",
  Description: "Description",
  description: "description",
  "Register Supplier Credit": "Enregistrer un crédit fournisseur",
  "Credit Amount": "Montant du crédit",
  "Register payment": "Enregistrer un paiement",
  "Remaing amount": "Montant restant",
  "Amount to register": "Montant à enregistrer",
  "Finance account to use": "Compte financier à utiliser",
  "-- Select method": "-- Sélectionner une méthode",
  "Debt informations": "Informations sur la dette",
  transaction: "transaction",
  "Add supplier debt": "Enregistrer la dette d'un fournisseur",
};
